export default "__VITE_ASSET__d82875a8__"